(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    /*
   * Product header placement (mobile).
   *
   * 1. Tag the block immediately following #breadcrumbs-container as #product-header.
   *    content_for 'blocks' renders that block as opaque HTML, so we give it a stable
   *    id client-side.
   *
   * 2. On mobile only, relocate #product-header (and the secondary product name that
   *    lives inside #breadcrumbs-container) to sit directly after
   *    .breadcrumbs-mobile-wrapper so the order becomes:
   *    breadcrumbs -> secondary name -> product header -> media gallery -> rest of
   *    product details. Those nodes are nested deep inside .product-details, so this
   *    can't be done with CSS order alone (different containers); we move the nodes
   *    and let the CSS in snippets/product-information-content.liquid position them.
   *    Comment placeholders record the original positions so desktop layouts are
   *    restored untouched.
   *
   * 3. On mobile only, and on regular (non-bundle) PDPs, lift the Yotpo star-rating
   *    block back out of the relocated header and drop it inside the main variant
   *    picker, between the colour swatches (option position 1) and the size options
   *    (option position 2). The star rating is nested inside the header group in the
   *    template JSON, so by default it travels up with the header (step 2); bundle PDPs
   *    keep that behaviour (reviews stay in the header above the image) and are detected
   *    via the server-rendered .product-information__media--bundle class. One-size items
   *    render no size fieldset, so there the stars sit directly under the swatches; only
   *    products with no variant picker at all fall back to the top of the details column.
   *    A comment placeholder records the star rating's original position so desktop and
   *    bundle layouts are restored untouched. Because same-product variant changes morph
   *    the variant picker (dropping the relocated node), placement is re-applied on
   *    every variant:update.
   *
   * 4. On mobile only, and on personalizable PDPs only, move the price out of the
   *    relocated header to the top of the details column, so it reads below the media
   *    gallery carousel instead of above it. swapReviewsAndPrice() puts the price at the
   *    bottom of the header (see below), which is the right desktop order but rides above
   *    the gallery once the header is lifted. A comment placeholder records the in-header
   *    position so desktop is restored untouched.
   *
   * The move is gated on body.ab-product-header-top, which layout/theme.liquid sets
   * server-side for every product page. The guard also keeps this block inert when it
   * renders outside a PDP (e.g. a featured-product section on the homepage). The
   * anti-flicker mask (html.ab-ph-pending, see ab-product-header-antiflicker) hides the
   * grid until the move runs, so shoppers never see the header jump from its default
   * (below-gallery) position.
   */
  (function () {
    var VARIANT_CLASS = 'ab-product-header-top';
    var PENDING_CLASS = 'ab-ph-pending';
    // The Yotpo star-rating block renders inside a Shopify app-block wrapper; it is the
    // only app block nested inside #product-header.
    var REVIEW_SELECTOR = '.shopify-app-block';
    var mobile = window.matchMedia('(max-width: 1079px)');
    var placeholder = null;
    var secondaryName = null;
    var secondaryPlaceholder = null;
    var reviewBlock = null;
    var reviewPlaceholder = null;
    var priceBlock = null;
    var pricePlaceholder = null;

    function personalizableDetails() {
      return document.querySelector('.product-details[data-personalizable="true"]');
    }

    function tagProductHeader() {
      // "The element after the breadcrumbs" only identifies the header before it has been
      // relocated. Once moveToMobile() lifts it above the gallery, #breadcrumbs-container is
      // followed by the variant picker instead, and the relocated header survives a
      // product-switch morph with its id intact. Re-tagging on that second init() would stamp
      // the id onto the picker, which then inherits the header's padding rules (ID beats
      // .spacing-style, so the picker loses its 20px top padding). Bail while a header is
      // already tagged.
      if (document.getElementById('product-header')) return;

      var breadcrumbs = document.getElementById('breadcrumbs-container');
      if (!breadcrumbs) return;

      var next = breadcrumbs.nextElementSibling;
      if (next) {
        next.id = 'product-header';
      }
    }

    // Secondary name is rendered inside #breadcrumbs-container for the desktop
    // breadcrumbs row; cache it before we move the header so we can lift it too.
    function cacheSecondaryName() {
      if (secondaryName) return;
      var breadcrumbs = document.getElementById('breadcrumbs-container');
      if (!breadcrumbs) return;
      secondaryName = breadcrumbs.querySelector('.product-secondary-name');
    }

    function restoreSecondaryName() {
      if (!secondaryName || !secondaryPlaceholder || !secondaryPlaceholder.parentNode) return;
      if (secondaryName.previousSibling === secondaryPlaceholder) return;

      secondaryPlaceholder.parentNode.insertBefore(secondaryName, secondaryPlaceholder.nextSibling);
    }

    // Bundle PDPs render the media wrapper with this class (see
    // snippets/product-information-content.liquid); on those we keep reviews in the header.
    function isBundlePdp() {
      return document.querySelector('.product-information__media--bundle') !== null;
    }

    // Cache the star-rating block while it is still nested inside the header, so we can
    // move it back and forth without relying on a live descendant lookup.
    function cacheReviewBlock() {
      if (reviewBlock) return;
      var header = document.getElementById('product-header');
      if (!header) return;
      reviewBlock = header.querySelector(REVIEW_SELECTOR);
    }

    function moveToMobile() {
      var header = document.getElementById('product-header');
      var wrapper = document.querySelector('.breadcrumbs-mobile-wrapper');
      if (!header || !wrapper) return;

      if (!placeholder) {
        placeholder = document.createComment('product-header-anchor');
        header.parentNode.insertBefore(placeholder, header);
      }

      // Build DOM order explicitly: breadcrumbs -> secondary name -> product header.
      if (secondaryName) {
        if (!secondaryPlaceholder) {
          secondaryPlaceholder = document.createComment('product-secondary-name-anchor');
          secondaryName.parentNode.insertBefore(secondaryPlaceholder, secondaryName);
        }
        if (secondaryName.previousElementSibling !== wrapper) {
          wrapper.insertAdjacentElement('afterend', secondaryName);
        }
        if (header.previousElementSibling !== secondaryName) {
          secondaryName.insertAdjacentElement('afterend', header);
        }
      } else if (header.previousElementSibling !== wrapper) {
        wrapper.insertAdjacentElement('afterend', header);
      }
    }

    function handleVariantUpdate(event) {
      var detail = event.detail;
      var isNewProduct = Boolean(detail && detail.data && detail.data.newProduct);

      if (isNewProduct) {
        // Combined-listing / product switch: main is morphed and the header star
        // rating is re-rendered, so reset all cached nodes and re-run placement.
        placeholder = null;
        secondaryName = null;
        secondaryPlaceholder = null;
        reviewBlock = null;
        reviewPlaceholder = null;
        priceBlock = null;
        pricePlaceholder = null;
        init();
        return;
      }

      // Same-product variant change: the variant picker was morphed in place,
      // detaching the relocated star rating. Re-apply so it stays between swatches
      // and sizes (the cached node keeps its rendered content while detached).
      apply();
    }

    function restore() {
      restoreSecondaryName();

      var header = document.getElementById('product-header');
      if (!header || !placeholder || !placeholder.parentNode) return;
      if (header.previousSibling === placeholder) return;

      placeholder.parentNode.insertBefore(header, placeholder);
    }

    // Record the star rating's original (in-header) position once, so desktop and
    // bundle layouts can restore it untouched.
    function ensureReviewPlaceholder() {
      if (reviewPlaceholder || !reviewBlock || !reviewBlock.parentNode) return;
      reviewPlaceholder = document.createComment('product-review-anchor');
      reviewBlock.parentNode.insertBefore(reviewPlaceholder, reviewBlock);
    }

    // Mobile, non-bundle PDPs: drop the star rating between the colour swatches
    // (option position 1) and the size options (option position 2) inside the main
    // variant picker. Same-product variant changes morph the picker and drop the
    // relocated node, so this runs again on every variant:update (see
    // handleVariantUpdate).
    function moveReviewsBetweenVariants() {
      if (isBundlePdp() || !reviewBlock) return;

      var picker = document.querySelector('variant-picker[data-template-product-match="true"]');
      var sizeFieldset = picker
        ? picker.querySelector('fieldset[data-fieldset-option-position="2"]')
        : null;

      if (sizeFieldset) {
        // variant-main-picker renders the exposed fit note (when the product has one) as
        // the size fieldset's immediate previous sibling. The stars belong above that note,
        // so anchor on the note when it is there and on the fieldset otherwise.
        var previous = sizeFieldset.previousElementSibling;
        var anchor =
          previous && previous.classList.contains('exposed-fit-note') ? previous : sizeFieldset;

        if (anchor.previousElementSibling === reviewBlock) return;
        ensureReviewPlaceholder();
        anchor.parentNode.insertBefore(reviewBlock, anchor);
        return;
      }

      // One-size items render no size fieldset (variant-main-picker skips a size option
      // with a single value), so there is nothing to sit in front of. Keep the stars in
      // the picker anyway, directly under the colour swatches.
      var colorFieldset = picker
        ? picker.querySelector('fieldset[data-fieldset-option-position="1"]')
        : null;

      if (colorFieldset) {
        if (colorFieldset.nextElementSibling === reviewBlock) return;
        ensureReviewPlaceholder();
        colorFieldset.insertAdjacentElement('afterend', reviewBlock);
        return;
      }

      // No variant picker at all (single-variant products render none); fall back to the
      // top of the details column, just below the gallery.
      var breadcrumbs = document.getElementById('breadcrumbs-container');
      if (!breadcrumbs || breadcrumbs.nextElementSibling === reviewBlock) return;
      ensureReviewPlaceholder();
      breadcrumbs.insertAdjacentElement('afterend', reviewBlock);
    }

    function restoreReviews() {
      if (!reviewBlock || !reviewPlaceholder || !reviewPlaceholder.parentNode) return;
      if (reviewBlock.previousSibling === reviewPlaceholder) return;

      reviewPlaceholder.parentNode.insertBefore(reviewBlock, reviewPlaceholder.nextSibling);
    }

    function cachePriceBlock() {
      if (priceBlock || !personalizableDetails()) return;
      var header = document.getElementById('product-header');
      if (!header) return;
      priceBlock = header.querySelector('product-price');
    }

    function ensurePricePlaceholder() {
      if (pricePlaceholder || !priceBlock || !priceBlock.parentNode) return;
      pricePlaceholder = document.createComment('product-price-anchor');
      priceBlock.parentNode.insertBefore(pricePlaceholder, priceBlock);
    }

    function movePriceBelowGallery() {
      if (!priceBlock) return;

      var breadcrumbs = document.getElementById('breadcrumbs-container');
      if (!breadcrumbs || breadcrumbs.nextElementSibling === priceBlock) return;

      ensurePricePlaceholder();
      breadcrumbs.insertAdjacentElement('afterend', priceBlock);
    }

    function restorePrice() {
      if (!priceBlock || !pricePlaceholder || !pricePlaceholder.parentNode) return;
      if (priceBlock.previousSibling === pricePlaceholder) return;

      pricePlaceholder.parentNode.insertBefore(priceBlock, pricePlaceholder.nextSibling);
    }

    function reveal() {
      document.documentElement.classList.remove(PENDING_CLASS);
    }

    /*
     * Personalizable products (e.g. the blazer atelier) show the review stars
     * inside #product-header — so they ride above the media gallery on mobile and
     * above the price on desktop — with the price dropped below. The theme renders
     * the price inside the header group and the review-stars app block as a sibling
     * detail block, so this swaps the two nodes once. It runs before the header is
     * relocated (under the same anti-flicker mask) and is a permanent, viewport-
     * independent change, so it doesn't need re-applying on resize. Gated on
     * [data-personalizable] so only personalizable products are affected, on any
     * product template.
     */
    function swapReviewsAndPrice() {
      var details = personalizableDetails();
      if (!details || details.dataset.reviewsPriceSwapped === 'true') return;

      var price = details.querySelector('product-price');
      var stars = details.querySelector('[id*="yotpo_product_reviews_star_rating"]');
      if (!price || !stars) return;

      var priceParent = price.parentNode;
      var starsParent = stars.parentNode;
      if (!priceParent || !starsParent) return;

      var priceNext = price.nextSibling;
      var starsNext = stars.nextSibling;

      // Move the stars into the price's slot (inside the header group)...
      priceParent.insertBefore(stars, priceNext);
      // ...and the price into the stars' old slot (a top-level detail block).
      starsParent.insertBefore(price, starsNext);

      details.dataset.reviewsPriceSwapped = 'true';
    }

    function apply() {
      if (document.body.classList.contains(VARIANT_CLASS) && mobile.matches) {
        moveToMobile();
        moveReviewsBetweenVariants();
        // After the reviews, so the price takes the slot directly under the gallery.
        movePriceBelowGallery();
      } else {
        restorePrice();
        restoreReviews();
        restore();
      }
      reveal();
    }

    function init() {
      swapReviewsAndPrice();
      tagProductHeader();
      cacheSecondaryName();
      cacheReviewBlock();
      cachePriceBlock();
      apply();
    }

    function handleProductSwitch(event) {
      if (event.target !== document) return;
      var detail = event.detail;
      if (!detail || !detail.data || !detail.data.newProduct) return;

      placeholder = null;
      secondaryName = null;
      secondaryPlaceholder = null;
      priceBlock = null;
      pricePlaceholder = null;
      init();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    mobile.addEventListener('change', apply);
    document.addEventListener('variant:update', handleVariantUpdate);
    document.addEventListener('variant:update', handleProductSwitch);

    // Product-family / combined-listing swaps morph `main` (see variant-picker.js
    // updateMain), which resets the details column to its server order — undoing the
    // stars/price swap and dropping the runtime #product-header id — then dispatches
    // variant:update. Re-establish the placement in that case. The swap flag is the
    // reliable signal that the morph reset the column: a same-product variant change
    // only morphs the variant-picker subtree, so the flag (and our layout) survives
    // and this is a no-op. 'variant:update' mirrors ThemeEvents.variantUpdate (this
    // block is inline JS with no module imports).
    document.addEventListener('variant:update', function () {
      requestAnimationFrame(function () {
        var details = personalizableDetails();
        if (!details || details.dataset.reviewsPriceSwapped === 'true') return;

        // Cached anchors point at nodes the morph discarded; drop them so init()
        // re-establishes them against the fresh DOM.
        placeholder = null;
        secondaryName = null;
        secondaryPlaceholder = null;
        priceBlock = null;
        pricePlaceholder = null;
        init();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["contact-info"] && !Shopify.designMode) return;
  try {
    (function () {
    const hoursElements = document.querySelectorAll('.contact-info__hours-status[data-hours]');

    hoursElements.forEach((element) => {
      const hoursText = element.dataset.hours;
      const isOpen = checkIfOpen(hoursText);
      element.dataset.open = isOpen;
    });

    function checkIfOpen(hoursText) {
      try {
        // Get current time in EST
        const now = new Date();
        const estTime = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));
        const currentDay = estTime.getDay(); // 0 = Sunday, 1 = Monday, etc.
        const currentHour = estTime.getHours();
        const currentMinutes = estTime.getMinutes();
        const currentTimeInMinutes = currentHour * 60 + currentMinutes;

        // Parse hours string like "Monday - Friday 10AM - 6PM EST"
        const lines = hoursText.split(/\n|<br\s*\/?>/i);

        for (const line of lines) {
          const trimmedLine = line.trim();
          if (!trimmedLine) continue;

          // Match pattern: "Day - Day HH:MM AM/PM - HH:MM AM/PM" or "Day HH:MM AM/PM - HH:MM AM/PM"
          const dayRangeMatch = trimmedLine.match(
            /(\w+)\s*-\s*(\w+)\s+(\d{1,2})(?::(\d{2}))?\s*(AM|PM)\s*-\s*(\d{1,2})(?::(\d{2}))?\s*(AM|PM)/i,
          );
          const singleDayMatch = trimmedLine.match(
            /^(\w+)\s+(\d{1,2})(?::(\d{2}))?\s*(AM|PM)\s*-\s*(\d{1,2})(?::(\d{2}))?\s*(AM|PM)/i,
          );

          if (dayRangeMatch) {
            const [, startDay, endDay, openHour, openMin, openPeriod, closeHour, closeMin, closePeriod] = dayRangeMatch;
            const startDayNum = getDayNumber(startDay);
            const endDayNum = getDayNumber(endDay);

            if (isDayInRange(currentDay, startDayNum, endDayNum)) {
              const openTime = parseTime(parseInt(openHour), parseInt(openMin || 0), openPeriod);
              const closeTime = parseTime(parseInt(closeHour), parseInt(closeMin || 0), closePeriod);

              if (currentTimeInMinutes >= openTime && currentTimeInMinutes < closeTime) {
                return true;
              }
            }
          } else if (singleDayMatch) {
            const [, day, openHour, openMin, openPeriod, closeHour, closeMin, closePeriod] = singleDayMatch;
            const dayNum = getDayNumber(day);

            if (currentDay === dayNum) {
              const openTime = parseTime(parseInt(openHour), parseInt(openMin || 0), openPeriod);
              const closeTime = parseTime(parseInt(closeHour), parseInt(closeMin || 0), closePeriod);

              if (currentTimeInMinutes >= openTime && currentTimeInMinutes < closeTime) {
                return true;
              }
            }
          }
        }

        return false;
      } catch (e) {
        console.error('Error parsing hours:', e);
        return false;
      }
    }

    function getDayNumber(dayName) {
      const days = {
        sunday: 0,
        sun: 0,
        monday: 1,
        mon: 1,
        tuesday: 2,
        tue: 2,
        tues: 2,
        wednesday: 3,
        wed: 3,
        thursday: 4,
        thu: 4,
        thur: 4,
        thurs: 4,
        friday: 5,
        fri: 5,
        saturday: 6,
        sat: 6,
      };
      return days[dayName.toLowerCase()] ?? -1;
    }

    function isDayInRange(currentDay, startDay, endDay) {
      if (startDay <= endDay) {
        return currentDay >= startDay && currentDay <= endDay;
      } else {
        // Wraps around week (e.g., Friday - Monday)
        return currentDay >= startDay || currentDay <= endDay;
      }
    }

    function parseTime(hour, minutes, period) {
      let h = hour;
      if (period.toUpperCase() === 'PM' && hour !== 12) {
        h += 12;
      } else if (period.toUpperCase() === 'AM' && hour === 12) {
        h = 0;
      }
      return h * 60 + minutes;
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
